import { IPartner } from 'clickNgo/entities/partner/models'

export const mapApolloSearchPartnerTermsFromPartner = (partner: IPartner) => ({
  addressLine: partner.addressLine1,
  city: partner.city,
  country: partner.countryCode,
  name: partner.companyLegalName,
  communicationName: partner.communicationName,
  taxId: partner.taxId,
  locationId: partner.locationId,
  postalCode: partner.zipCode,
  stateProvince: partner.state,
  hierarchyType: partner.hierarchyType,
})
